import React from "react";
import { UiGoalsItem } from "../../../components/cards/UiInfoCardContent";
import { UiAddImageInput } from "../../../components/common/UiAddImageInput";
import { UiCardTitle } from "../../../components/common/UiCardTitle";
import { UiContentWr } from "../../../components/common/UiPageElements";
import { UiSpaceLeft } from "../../../components/common/UiSpaceLeft";
import { UiCol, UiRowContainer, UiSingleRow } from "../../../components/grid-container/GridContainer";
import UserImage from '../../../../../styles/img/user.jpg'

export const KeyInformation = (props) => {

    const TeamImage = [ UserImage,UserImage ,UserImage,UserImage ];

    return (
        <>
            <UiContentWr>
                <UiRowContainer fluid="fluid" className="sb-key-info">
                    <UiCol lg="12">
                        <UiCardTitle title="Key Information" />
                    </UiCol>

                    <UiCol lg="9">
                        <UiSingleRow className="sb-key-info__key-info">
                            <UiCol lg="6">
                                <p><strong>Lorem Epsum: </strong> 9238BCD</p>
                                <p><strong>Date Set Up: </strong> Monday 22nd March 2023</p>
                            </UiCol>
                            <UiCol lg="6">
                                <p><strong>Order Name: </strong> London version 3 trip</p>
                                <p><strong>Points Total: </strong> 4,750 Points</p>
                            </UiCol>
                            <UiCol lg="12" className="sb-keyinfo-split">
                                <p><strong>Involves 4 Friends: </strong> </p>
                                <UiGoalsItem                                    
                                    splitTeam={true}                                  
                                    team="Includes You, Jane, Rick & Jessica"
                                    images={TeamImage}
                                    hideProgress={true}
                                />
                            </UiCol>
                            <UiCol lg="12">
                                <p className="sb-key-info-sub-desc">Timperdiet gravida scelerisque odio nunc. Eget felis, odio bibendum quis eget sit lorem donec diam. Volutpat sed orci turpis sit dolor est a pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu. Ut commodo, eget lorem venenatis urna. Pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu.</p>
                            </UiCol>
                        </UiSingleRow>
                    </UiCol>

                    <UiCol lg="3">
                        <UiAddImageInput
                            title="Add Goal Image" />
                    </UiCol>

                </UiRowContainer>
            </UiContentWr>
        </>
    )
}